import request from '@/utils/request'
export function fireAlarm(token, data) {
  return request({
    url: '/api/fireAlarm/fireAlarmNew',
    method: 'get',
    params: data
  })
}
// 接警信息表格
// /called/queryCalledRecoedList
export function queryCalledRecoedList(token, pageNum, pageSize) {
  return request({
    url: `/api/called/queryCalledRecoedList?pageNum=${pageNum}&pageSize=${pageSize}`,
    method: 'get'
  })
}
// /called/queryCustData
export function queryCustData(token, custId) {
  return request({
    url: `/api/called/queryCustData?custId=${custId}`,
    method: 'get'
  })
}
// /called/queryJccUserList  获取接警处已有账号
export function queryJccUserList(token) {
  return request({
    url: '/api/called/queryJccUserList ',
    method: 'get'
  })
}
// /called/insertCalledUser 创建接警处
export function insertCalledUser(token, data) {
  return request({
    url: `/api/called/insertCalledUser?userId=${data.Architecture}&longitude=${data.lng}&latitudu=${data.lat}`,
    method: 'POST',
    params: {}
  })
}
// /called/insertCalledRecord 生成接警记录
export function insertCalledRecord(token) {
  return request({
    url: '/api/called/insertCalledRecord',
    method: 'POST',
    params: {}
  })
}
// /called/queryCalledAlarmList  获取接警处
export function queryCalledAlarmList(token) {
  return request({
    url: '/api/called/queryCalledAlarmList',
    method: 'get'
  })
}
// called/queryCustBindInfo
export function queryCustBindInfo(token, custName) {
  return request({
    url: `/api/called/queryCustBindInfo?custName=${custName}`,
    method: 'get'
  })
}
// called/queryAllJcc
export function queryAllJcc(token, custName) {
  return request({
    url: `/api/called/queryAllJcc`,
    method: 'get'
  })
}

// called/custToCalledBind?custId=1253&calledUser=JJC001
export function custToCalledBind(token, custId, calledUser) {
  return request({
    url: `/api/called/custToCalledBind?custId=${custId}&calledUser=${calledUser}`,
    method: 'POST'
  })
}
